export default [
    {
        type: "uni",
        id: 1,
        items: [
            {
                id: 1,
                text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
            },
            {
                id: 2,
                text: "Der Dozent/Die Dozentin hat die Inhalte angemessen wiederholt.",
            },
            {
                id: 3,
                text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
            },
            {
                id: 4,
                text: "Der Dozent/Die Dozentin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
            },
            {
                id: 5,
                text: "Der Dozent/Die Dozentin gab die Möglichkeit, Themen zu diskutieren.",
            },
            {
                id: 6,
                text: "Der Dozent/Die Dozentin war stets gut vorbereitet.",
            },
            {
                id: 7,
                text: "Der Dozent/Die Dozentin war fachlich kompetent",
            },
            {
                id: 8,
                text: "Der Dozent/Die Dozentin konnte Kompliziertes verständlich machen.",
            },
            {
                id: 9,
                text: "Dem Dozenten/Der Dozentin war es wichtig, dass die Teilnehmer/Teilnehmerinnen etwas lernen.",
            },
            {
                id: 10,
                text: "Der Dozent/Die Dozentin motivierte die Teilnehmer/Teilnehmerinnen.",
            },
            {
                id: 11,
                text: "Das Lernziel wurde mir deutlich.",
            },
            {
                id: 12,
                text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
            },
            {
                id: 13,
                text: "Die Veranstaltung war übersichtlich und verständlich.",
            },
            {
                id: 14,
                text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
            },
            {
                id: 15,
                text: "Ich habe mich schon vor der Veranstaltung für das Thema interessiert.",
            },
            {
                id: 16,
                text: "Die Themen der Veranstaltung waren für das Orientierungspraktikum relevant.",
            },
            {
                id: 17,
                text: "Ich habe das Gefühl in der Veranstaltung Wichtiges gelernt zu haben.",
            },
            {
                id: 18,
                text: "Die behandelten Themen enthalten Bezüge zu der Arbeit als Lehrkraft.",
            },
            {
                id: 19,
                text: "Die Schwere des Stoffes war angemessen.",
            },
            {
                id: 20,
                text: "Der Umfang des Stoffes war angemessen.",
            },
            {
                id: 21,
                text: "Das Tempo der Veranstaltung war angemessen.",
            },
            {
                id: 22,
                text: "Die Anforderungen der Veranstaltung waren angemessen.",
            },
            {
                id: 23,
                text: "Der Zeitaufwand für die Veranstaltung insgesamt (inkl. Vor- und Nachbereitung) war angemessen.",
            },
            {
                id: 24,
                text: "Insgesamt hat mich die Veranstaltung überfordert.",
            },
            {
                id: 25,
                text: "Insgesamt fand ich die Veranstaltung gut.",
            },
            {
                id: 26,
                text: "In der Veranstaltung habe ich viel gelernt.",
            },
            {
                id: 27,
                text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
            },
            {
                id: 28,
                text: "Die Veranstaltung hat mich gut auf das Praktikum vorbereitet.",
            },
            {
                id: 29,
                text: "Ich würde die Veranstaltung weiterempfehlen.",
            },
        ],
    },
    {
        type: "uni",
        id: 2,
        title:
            "Wie sinnvoll sind Ihrer Meinung nach die folgenden Bausteine zur Praktikumsvorbereitung?",
        items: [
            {
                id: 30,
                text: "Unterrichtsplanung",
            },
            {
                id: 31,
                text: "Unterrichtsbeobachtung",
            },
            {
                id: 32,
                text: "Selbstreflexion",
            },
        ],
    },
    {
        type: "text",
        id: 3,
        items: [
            {
                id: 33,
                text: "Was hätten Sie sich über die behandelten Inhalte im vor- und nachbereitenden Seminar hinaus gewünscht?",
            },
        ],
    },
    {
        type: "uni",
        id: 4,
        title:
            "Betreuung durch den Dozenten / die Dozentin während des Praktikums",
        items: [
            {
                id: 34,
                text: "Der Dozent war für mich erreichbar.",
            },
            {
                id: 35,
                text: "Der Dozent konnte meine Fragen kompetent beantworten.",
            },
            {
                id: 36,
                text: "Einen Schulbesuch des Dozenten / der Dozentin halte ich für sinnvoll.",
            },
        ],
    },
    {
        type: "uni",
        id: 5,
        title:
            "Betreuung durch die Schule und die betreuende Lehrkraft<br><br>Der folgende Fragenblock bezieht sich auf ihr Praktikum in der Grundschule",
        items: [
            {
                id: 37,
                text: "Ich wurde vom ersten Tag an ins Schulleben integriert.",
            },
            {
                id: 38,
                text: "Ich wurde über die bevorstehenden Aufgaben und Aktivitäten (Stundenplanung, Elternabende, Klassenkonferenzen etc.) rechtzeitig informiert.",
            },
            {
                id: 39,
                text: "Die Lehrkräfte an der Schule waren für Fragen offen.",
            },
            {
                id: 40,
                text: "Die betreuende Lehrkraft ging auf Fragen und Anregungen aus dem Team ein.",
            },
            {
                id: 41,
                text: "Die Vor- und Nachbesprechungen des Unterrichts mit der betreuenden Lehrkraft waren sehr hilfreich.",
            },
        ],
    },
    {
        type: "uni",
        id: 6,
        title:
            "Der folgende Fragenblock bezieht sich auf ihr Praktikum in der weiterführenden Schule (falls zutreffend)",
        items: [
            {
                id: 42,
                text: "Ich wurde vom ersten Tag an ins Schulleben integriert.",
            },
            {
                id: 43,
                text: "Ich wurde über die bevorstehenden Aufgaben und Aktivitäten (Stundenplanung, Elternabende, Klassenkonferenzen etc.) rechtzeitig informiert.",
            },
            {
                id: 44,
                text: "Die Lehrkräfte an der Schule waren für Fragen offen.",
            },
            {
                id: 45,
                text: "Die betreuende Lehrkraft ging auf Fragen und Anregungen aus dem Team ein.",
            },
            {
                id: 46,
                text: "Die Vor- und Nachbesprechungen des Unterrichts mit der betreuenden Lehrkraft waren sehr hilfreich.",
            },
        ],
    },
    {
        type: "uni",
        id: 7,
        title: "Evaluation des Praktikums allgemein",
        items: [
            {
                id: 47,
                text: "Das Praktikum hat mir geholfen meine Berufswahl zu überprüfen.",
            },
            {
                id: 48,
                text: "Durch das Praktikum habe ich einen guten Einblick in den Berufsalltag einer Lehrkraft bekommen.",
            },
            {
                id: 49,
                text: "Im Praktikum habe ich viel gelernt.",
            },
            {
                id: 50,
                text: "Wie zufrieden sind Sie mit dem Praktikum insgesamt?",
            },
            {
                id: 51,
                text: "Wie sinnvoll finden Sie Unterrichtsbeobachtungen im Allgemeinen?",
            },
            {
                id: 52,
                text: "Wie sinnvoll finden Sie eine gemeinsame Bearbeitung des Beobachtungsbogens?",
            },
            {
                id: 53,
                text: "Wie sinnvoll finden Sie eigene Unterrichtsversuche?",
            },
        ],
    },
    {
        type: "special",
        id: 8,
        items: [
            {
                id: 54,
                text: "Sollte das Praktikumsmodul so weiter geführt werden, wie es jetzt ist?",
                label: [
                    {
                        id: 1,
                        text: "Ja",
                    },
                    {
                        id: 2,
                        text: "Nein",
                    },
                ],
            },
        ],
    },
    {
        type: "text",
        id: 9,
        items: [
            {
                id: 55,
                text: "Wenn nein, was sollte Ihrer Meinung nach geändert werden?",
            },
            {
                id: 56,
                text: "Weitere Anmerkungen",
            },
        ],
    },
];